import { restrictedEmails } from "../components/adminEmails";
import { IMap } from "../globals/interfaces";

export default function useRestrictedAccess (s_email: string) {
    const set = new Set(restrictedEmails);
    return set.has(s_email.toLowerCase());
}